import { AccountLayout } from '../../layouts';
import { OtpForm } from '../../components/VerifyOtpForm';

export const VerifyOtpPage = () => {
  return (
    <AccountLayout
      contents={<OtpForm />}
      contentColumns={5}
    />
  );
};
